<template>
    <div class="all-continue">
        <tabbar :tabbarIndex="0"></tabbar>
        <img width="100%" :src="web_top_imgurl" @click="link(web_top_linkurl)" alt="" />
        <marquee behavior="scroll" class="tishi">{{ web_rolling_notice }}</marquee>
        <div class="kefu" @click="clicked_OnlineService()" style="cursor: pointer;">
            <img style="margin-top: 30px; text-align: center" src="../../images/kefu.png" />
            <div class="kefu-zi">
            在线客服
            </div>
            <div class="kefu-zi">
            售后处理
            </div>
        </div>
        <div class="big-box" @click="a()">
            <div class="goods-item" v-for="(item,index) in shopList" :key="index">
                <img :src="item.pc_img" alt="">
                <div class="goods-name">
                    <h3>{{ item.setmeal_name }}</h3>
                    <p style="color: red;margin-top: 10px;">套餐编号：{{ item.setmeal_code }}</p>
                </div>
                <div class="goods-caozuo">
                    <div class="delate">
                        <!-- <img src="../../images/delate.png" alt="">
                        <div>删除</div> -->
                    </div>
                    <div class="num-box">
                        <div class="num-jia" @click="jian(item)">-</div>
                        <div>{{ item.amount }}</div>
                        <div class="num-jia" @click="jia(item)">+</div>
                    </div>
                </div>
            </div>
            <button class="is_dui" @click="duihuan()">立即兑换</button>
        </div>

        <c-footer></c-footer>
        <success-cover :isShow="isShow" :showContent="showContent"></success-cover>

    </div>
</template>

<script>
import tabbar from "../../components/tabbar/tabbar";
import footer from "../../components/footer/footer";
import successCover from "../../components/successCover/successCover";
import {
  cardInterTCRequest,
  cardInfoRequest,
} from "../../public/js/service";
var interval;

export default{
    data(){
        return{
            sysId:'',//sysid
            web_tel:'',//客服电话
            web_rolling_notice:'',//滚动公告
            web_top_imgurl:'',//pc顶部图片链接
            web_top_linkurl:'',//pc顶部跳转链接
            token:'',//token
            cardTypeId:'',//卡型id
            card_type:'',//卡型
            TCinfo:{},//卡信息
            cardCartId:1,//套餐变更记录id
            pageNo:1,
            pageSize:10,
            shopList:[],//已选套餐列表
        }
    },
    components: {
        tabbar,
        cFooter: footer,
        successCover,
    },
    methods:{
        //获取已选套餐列表
        getshopList(){
            let data={
                // cardCartId: this.cardCartId,
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                sysId: this.sysId
            };
            let afterUrl="card/cartlist";
            cardInterTCRequest(afterUrl,data).then((res)=>{
                if(res){
                    this.shopList=res.rows
                }
            })
        },
        getCardInfo() {
            let data = {
                cardTypeId: this.cardTypeId,
                sysId: this.sysId,
                isLoadMaxQTY:1
            };
            cardInfoRequest(data).then((res) => {
                if (res) {
                    this.TCinfo = res.data[0];
                }
            });
        },
        a(){
            console.log(interval)
        },
        duihuan(){
            // if(this.TCInfo.is_deal!=0||this.TCInfo.available_qty<=0&&this.card_type==4){
            //     return;
            // }

            let obj = {
                token: this.token,
                setmealId: this.shopList[0].setmeal_id,
                cardTypeId: this.cardTypeId,
            };
            // let obj="111";
            this.$router.push(
                "/address1?obj=" + encodeURIComponent(JSON.stringify(obj))
            );
        },
        jia(item){
            var that=this
            let data={
                number: 1,
                province: "string",
                setmealId: item.setmeal_id,
                sysId: this.sysId
            };
            let afterUrl="card/cartadd";
            cardInterTCRequest(afterUrl,data).then((res)=>{
                if(res){
                    item.amount= Number(item.amount)+1
                    that.getshopList()
                }
            })
        },
        jian(item){
            var that=this
            let data={
                number: -1,
                province: "string",
                setmealId: item.setmeal_id,
                sysId: this.sysId
            };
            let afterUrl="card/cartadd";
            cardInterTCRequest(afterUrl,data).then((res)=>{
                if(res){
                    item.amount=Number(item.amount)-1
                    that.getshopList()
                }
            })
        },
    },
    mounted() {
        console.log(localStorage)
        // 4.mounted
        this.sysId = localStorage.sysId || "";
        // this.citys_path = localStorage.citys_path || "";
        this.web_tel = JSON.parse(localStorage.web_tel) || "";
        this.web_rolling_notice = localStorage.web_rolling_notice || ""; //滚动公告
        this.web_top_imgurl = localStorage.web_top_imgurl || "";
        this.web_top_linkurl = localStorage.web_top_linkurl || "";

        let res = JSON.parse(decodeURIComponent(this.$route.query.obj));
        this.token = res.token;
        this.cardTypeId = res.cardTypeId;
        this.card_type = res.card_type;

        interval = setInterval(this.changePos, this.delay);
        this.getshopList();
        this.getCardInfo();
    },
}
</script>

<style scoped lang="scss">
@import "./shop.scss";
.kefu{
    width: 70px;
    height: 180px;
    background-color: #fff;
    box-shadow: 1px 1px 5px #666;
    text-align: center;
    position: fixed;
    right: 40px;
    >.kefu-zi{
        height: 30px;
        line-height: 30px;
        background-color: #cc7f0c;
        color: #fff;
        margin-top: 10px;
    }
}
</style>
